import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import ContentLayout from "../../components/layout-components/ContentLayout";
import CustomIconButton from "../../components/CustomIconButton";
import {
  Box,
  InputBase,
  Tooltip,
  useMediaQuery,
  styled,
  Typography,
  Avatar,
  CircularProgress,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import CustomDataTable from "../../components/CustomDataTable";
import CommonUtil from "../../util/CommonUtils";
import {
  batchMembersArchive,
  batchMembersUnarchive,
  downloadUserImportTemplate,
  importMembers,
  softDeleteMember,
  userList,
} from "../../services/MemberService";
import AddTeamLeadsToUsers from "./AddTeamLeadsToUsers";
import { ReactComponent as TableViewListIcon } from "../../assets/images/table-list-view.svg";
import { ReactComponent as ArchiveIcon } from "../../assets/images/archive-icon.svg";
import { ReactComponent as ArchiveIconDark } from "../../assets/images/archive-icon-dark.svg";
import { ReactComponent as EditIcon } from "../../assets/images/ralvie/EditIcon.svg";
import { ReactComponent as EditIconDark } from "../../assets/images/edit_icon_dark.svg";
import { ReactComponent as AddIcon } from "../../assets/images/ralvie/add-icon.svg";
import { ReactComponent as RefreshIcon } from "../../assets/images/refresh_icon.svg";
import { ReactComponent as FilterIcon } from "../../assets/images/filter-icon.svg";
import { ReactComponent as BiotimeIcon } from "../../assets/images/ralvie/biotime-icon.svg";
import { ReactComponent as EmptyMemberList } from "../../assets/images/ralvie/empty-member-list.svg";
import { ReactComponent as EmptyMemberListDark } from "../../assets/images/ralvie/empty-member-list-dark.svg";
import { useTranslation } from "react-i18next";
import { GridActionsCellItem } from "@mui/x-data-grid";
import ArchiveDialog from "../project/ArchiveDialog";
import { toast } from "sonner";
import CustomSearchField from "../../components/CustomSearchField";
import ImportDialog from "../../components/ImportDialog";
import MemberFilter from "./MemberFilter";
import UnarchiveDialog from "../project/UnarchiveDialog";
import AppContext from "../../config/AppContext";
import { ReactComponent as UnarchiveIcon } from "../../assets/images/ralvie/unarchive-icon.svg";
import { ReactComponent as UnarchiveDarkIcon } from "../../assets/images/ralvie/unarchive-darkicon.svg";
import "./member.scss";
import { sidebarContext } from "../../util/context";
import UpgradePopup from "../../components/subscription-component/UpgradePopup";
import RestrictPermissionPopup from "../../components/subscription-component/RestrictPermissionPopup";
import { getSubscriptionLimit } from "../../services/Subscription";
function MembersListView() {
  const { mode } = useContext(AppContext);
  const theme = useTheme();
  const isXlScreen = useMediaQuery(theme.breakpoints.up("xl"));
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { t } = useTranslation();
  const role = CommonUtil.getRoleCode();
  const isEditingRef = useRef(false);

  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const openFilter = Boolean(filterAnchorEl);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openArchiveDialog, setOpenArchiveDialog] = useState(false);
  const [openUnarchiveDialog, setOpenUnarchiveDialog] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [clearSearch, setClearSearch] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [openClose, setopenClose] = useState(false);
  const { subscriptionDetails } = useContext(sidebarContext);
  const [upgradePopupOpen, setUpgradePopupOpen] = useState(false);
  const [restrictPopupOpen, setRestrictPopupOpen] = useState(false);
  const [isLimitLoading, setIsLimitLoading] = useState(true);
  const [currentMemberCount, setCurrentMemberCount] = useState([]);
  const [totalMemberCount, setTotalMemberCount] = useState([]);
  const featureCode = "MEMBER_COUNT";
  const [archiveButton, setArchiveButton] = useState("");
  const [dataFetched, setDataFetched] = useState(false);
  const getRowClassName = () => {
    return selectedRows.length > 0 ? "selectedCheckboxVisible" : "";
  };

  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "& .MuiInputBase-input": {
      width: "100%",
      borderRadius: 4,
      position: "relative",
      fontSize: 16,
      padding: isXlScreen ? "12px 26px 12px 12px" : "9px 26px 7px 12px",
      backgroundColor: "transparent !important",
      opacity: 1,
      font: "normal normal normal 16px/20px Gotham",
      color: "#242424",
    },
  }));

  if (sessionStorage.getItem("is_reloaded_member"))
    window.history.replaceState({}, "");
  sessionStorage.setItem("is_reloaded_member", true);

  const location = useLocation();
  const { state } = location || {};

  const isMemberLimitExceeded = () => {
    if (!subscriptionDetails) return false;
    const isActive = ["live", "non_renewing"].includes(
      subscriptionDetails.status
    );
    // const memberCountLimit = subscriptionDetails?.features?.find(
    //   ({ feature }) => feature?.code === "PROJECT_COUNT"
    // )?.value;

    const limitExceeded = Number(currentMemberCount) >= Number(totalMemberCount) || false;
    if (!isActive) {
      if (!["OWNER"].includes(CommonUtil.getRoleCode())) {
        setRestrictPopupOpen(true);
        return true;
      } else {
        setUpgradePopupOpen(true);
        return true;
      }
    }
    if (limitExceeded) {
      if (!["OWNER"].includes(CommonUtil.getRoleCode())) {
        setRestrictPopupOpen(true);
      } else {
        setUpgradePopupOpen(true);
      }
    }
    return limitExceeded;
  };

  useEffect(() => {
    const fetchFeatureLimitDetails = async () => {
      try {
        const { data } = await getSubscriptionLimit(featureCode);
        if (data?.code !== "RCI0000") return;
        console.log("Feature Limit Data:", data?.data?.currValue);
        setCurrentMemberCount(data?.data?.currValue);
        setTotalMemberCount(data?.data?.limit);
      } catch (error) {
        console.error("Error fetching user details:", error.message);
      } finally {
        setIsLimitLoading(false);
      }
    };
    fetchFeatureLimitDetails();
  }, [rows]);

  const [filter, setFilter] = useState(() => {
    return (
      state?.filter || {
        status: "",
        name: "",
        email: "",
        searchNameOrEmail: "",
        toggleKeyToURL: true,
        departmentIds: [],
        designationIds: [],
      }
    );
  });
  useEffect(() => {
    if (!isLoading && rows !== undefined && rows !== null) {
      setDataFetched(true);
    }
  }, [isLoading, rows]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
    setopenClose(false);
  };

  useEffect(() => {
    loadMembersData(page, rowsPerPage);
  }, [page, rowsPerPage, filter]);

  const loadMembersData = (pageNumber, pageSize) => {
    setIsLoading(true);
    const departmentIds = filter?.departmentIds || [];
    const designationIds = filter?.designationIds || [];
    const status = filter?.status || "";
    const name = filter?.name || "";
    const email = filter?.email || "";
    const searchNameOrEmail = filter?.searchNameOrEmail || "";
    const toggleKeyToURL = filter?.toggleKeyToURL || "";

    const validDepartmentIds = departmentIds.includes(t("RAL0235"))
      ? []
      : departmentIds.filter((id) => id !== t("RAL0235"));
    const validDesignationIds = designationIds.includes(t("RAL0236"))
      ? []
      : designationIds.filter((id) => id !== t("RAL0236"));

    const requestData = {
      status,
      name,
      email,
      searchNameOrEmail,
      toggleKeyToURL,
      department: validDepartmentIds,
      designation: validDesignationIds,
    };

    userList(requestData, pageNumber, pageSize)
      .then((res) => {
        if (res?.status === 200 && res?.data?.code === "UASI0000") {
          let users = res.data.data.users;
          setRows(res?.data?.data?.users);
          setTotalRecords(res?.data?.data?.totalCount);
          setPage(res?.data?.data?.currentPage);
        } else {
          setRows([]);
          setTotalRecords(0);
        }
      })
      .catch((error) => {
        console.error("API call error:", error);
        setRows([]);
        setTotalRecords(0);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSwitch = () => {
    navigate("/members", {
      state: { filter: filter },
    });
  };

  const handleApplyFilters = (filters) => {
    const { departments, designations, status, refresherStatus } = filters;
    const { status: filterStatus, name, email, toggleKeyToURL } = status;
    const departmentIds = departments;
    const designationIds = designations;
    setRefresh(refresherStatus);

    setFilter((prevFilter) => ({
      ...prevFilter,
      status: filterStatus,
      name,
      email,
      toggleKeyToURL,
      departmentIds,
      designationIds,
    }));
  };

  const resetFilter = () => {
    setFilter({
      status: "",
      name: "",
      email: "",
      toggleKeyToURL: true,
      departmentIds: [t("RAL0235")],
      designationIds: [t("RAL0236")],
    });
    setRefresh(true);
    setClearSearch(true);
  };

  const handleAddTeamLeadsToUsers = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleArchiveMember = (id) => {
    setArchiveButton("single");
    setSelectedRows([id]);
    setSelectedMemberId(id);
    setOpenArchiveDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenArchiveDialog(false);
    setSelectedRows([]);
    setArchiveButton("");
  };

  const handleUnarchiveMembers = (id) => {
    setSelectedRows([id]);
    setSelectedMemberId(id);
    setArchiveButton("single");
    setOpenUnarchiveDialog(true);
  };

  const handleCloseUnarchiveDialog = () => {
    setArchiveButton("");
    setOpenUnarchiveDialog(false);
    setSelectedMemberId(null);
    setSelectedRows([]);
  };

  const handleEditMembers = useCallback(
    (id, view, memberRole) => {
      if (id) {

        if (role !== "OWNER" && memberRole === "Owner") {
          return;
        }

        const isActive = ["live", "non_renewing"].includes(
          subscriptionDetails?.status
        );
        if (!isActive) {
          if (!["OWNER"].includes(CommonUtil.getRoleCode())) {
            setRestrictPopupOpen(true);
          } else {
            setUpgradePopupOpen(true);
          }
        } else {
          isEditingRef.current = true;
          navigate(`/members/${id}`, { state: { fromView: view } });
          handleClose();
        }
      }
    },
    [navigate, subscriptionDetails]
  );

  // const handleImport = (file) => {
  //   const formData = new FormData();
  //   formData.append("file", file);
  //   setIsLoading(true);
  //   importMembers(formData).then((res) => {
  //     setIsLoading(false);
  //     if (res.data?.code === "RCI0000") toast.success(res.data.message);
  //     else toast.error(res.data.message);
  //     resetFilter();
  //   });
  // };

  const handleAddMembers = () => {
    if (isMemberLimitExceeded()) {
      if (!["OWNER"].includes(CommonUtil.getRoleCode())) {
        setRestrictPopupOpen(true);
      } else {
        setUpgradePopupOpen(true);
      }
    } else if (
      !subscriptionDetails ||
      Object.keys(subscriptionDetails).length === 0
    ) {
      if (!["OWNER"].includes(CommonUtil.getRoleCode())) {
        setRestrictPopupOpen(true);
      } else {
        setUpgradePopupOpen(true);
      }
    } else {
      navigate("/members/new", { state: { fromView: "list" } });
    }
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const selectedUserDetails = rows.filter((user) =>
    selectedRows.includes(user.id)
  );

  const getPopupTitle = (subscriptionDetails, t, isRestrictPopup = false) => {
    if (CommonUtil.getStatusCondition(subscriptionDetails)) {
      return isRestrictPopup ? t("RAL0902") : t("RAL0855");
    } else if (CommonUtil.isPlanCodeDefault(subscriptionDetails)) {
      return t("RAL0850");
    } else {
      return t("RAL0852");
    }
  };

  const getPopupContent = (subscriptionDetails, t, isRestrictPopup = false) => {
    if (CommonUtil.getStatusCondition(subscriptionDetails)) {
      return isRestrictPopup ? t("RAL0903") : t("RAL0856");
    } else if (CommonUtil.isPlanCodeDefault(subscriptionDetails)) {
      return t("RAL0849");
    } else {
      return t("RAL0851");
    }
  };

  const actions = (
    <Box display="flex" alignItems="center">
      {role !== "EMPLOYEE" && role !== "CLIENT" && role !== "TEAM LEAD" && role !== "MANAGER" &&(
        <>
          {selectedUserDetails.length > 0 && (
            <>
              {selectedUserDetails[0]?.status === "ARCHIVED" ? (
                <Box pr={2}>
                  <Box
                    sx={{
                      "& .unarchive_svg": {
                        transition: "color 0.3s ease",
                        color:
                          mode === "dark" ? "var(--color-33-50)" : "#242424cc",
                      },
                      "&:hover": {
                        "& .hover-text, & .unarchive_svg": {
                          color: mode === "dark" ? "#f8f8f8cc" : "#242424",
                        },
                      },
                    }}
                  >
                    <CustomIconButton
                      id="btn-unarchive-project"
                      title={t("RAL0535")}
                      size={isXlScreen ? "large" : "md"}
                      variant="square"
                      lightMode={
                        <UnarchiveIcon
                          id="member-archive-icon"
                          className="unarchive_svg"
                          height={isXlScreen ? "18px" : "14px"}
                        />
                      }
                      darkMode={
                        <UnarchiveDarkIcon
                          id="member-archive-icon"
                          className="unarchive_svg"
                          height={isXlScreen ? "18px" : "14px"}
                        />
                      }
                      onClick={() => { setArchiveButton("all"); setOpenUnarchiveDialog(true) }}
                    />
                  </Box>
                </Box>
              ) : (
                <>
                  {/* <Box item pr={2}>
                <CustomIconButton
                  id="btn-switch-project"
                  title={"Add TeamLeads"}
                  size={isXlScreen ? "large" : "md"}
                  variant="square"
                  lightMode={<Avatar height={isXlScreen ? "18px" : "14px"} />}
                  darkMode={<Avatar height={isXlScreen ? "18px" : "14px"} />}
                  onClick={handleAddTeamLeadsToUsers}
                />
              </Box> */}

                  <Box pr={2}>
                    <Box
                      sx={{
                        "& .archive_svg": {
                          transition: "color 0.3s ease",
                          color:
                            mode === "dark"
                              ? "var(--color-33-50)"
                              : "#242424cc",
                        },
                        "&:hover": {
                          "& .hover-text, & .archive_svg": {
                            color: mode === "dark" ? "#f8f8f8cc" : "#242424",
                          },
                        },
                      }}
                    >
                      <CustomIconButton
                        id="btn-archive-member"
                        title={t("RAL0173")}
                        size={isXlScreen ? "large" : "md"}
                        variant="square"
                        lightMode={
                          <ArchiveIcon
                            id="member-archive-icon"
                            className="archive_svg"
                            height={isXlScreen ? "18px" : "14px"}
                          />
                        }
                        darkMode={
                          <ArchiveIconDark
                            id="member-archive-icon"
                            className="archive_svg"
                            height={isXlScreen ? "18px" : "14px"}
                          />
                        }
                        onClick={() => { setArchiveButton("all"); setOpenArchiveDialog(true) }}
                      />
                    </Box>
                  </Box>
                </>
              )}
            </>
          )}
        </>
      )}

      {!selectedRows.length && (
        <>
          <Box item pr={2} className="memberSearchBox">
            <CustomSearchField
              id="btn-member-search"
              name="btn-member-search"
              clearSearch={clearSearch}
              // onChange={() => setClearSearch(false)}
              onChange={(value) => {
                setClearSearch(false);
                setPage(1);
                setFilter({ ...filter, searchNameOrEmail: value });
              }}
              label={t("RAL1209")}
              value={filter.searchNameOrEmail}
              size={isXlScreen ? "large" : "md"}
              onClick={(value) => {
                setClearSearch(false);
                setPage(1); 
                setFilter({ ...filter, searchNameOrEmail: value });
              }}
              onClear={(value) => {
                setClearSearch(true);
                setPage(1); 
                setFilter({ ...filter, searchNameOrEmail: value });
              }}
            />
          </Box>

          <Box item pr={2}>
            <Box
              sx={{
                "& .filter_svg": {
                  transition: "color 0.3s ease",
                  color: mode === "dark" ? "var(--color-33-50)" : "#242424cc",
                },
                "&:hover": {
                  "& .hover-text, & .filter_svg": {
                    color: mode === "dark" ? "#f8f8f8cc" : "#242424",
                  },
                },
              }}
            >
              <CustomIconButton
                id="btn-filter-project"
                title={t("RAL0224")}
                size={isXlScreen ? "large" : "md"}
                variant="square"
                lightMode={
                  <FilterIcon
                    id="member-filter-icon"
                    className="filter_svg"
                    height={isXlScreen ? "18px" : "14px"}
                  />
                }
                darkMode={
                  <FilterIcon
                    id="member-filter-icon"
                    className="filter_svg"
                    height={isXlScreen ? "18px" : "14px"}
                  />
                }
                onClick={handleFilterClick}
              />
            </Box>

            <MemberFilter
              title="Filter Title"
              open={openFilter}
              anchorEl={filterAnchorEl}
              onClose={handleFilterClose}
              filter={filter}
              MemberReset={resetFilter}
              BootstrapInput={BootstrapInput}
              onApplyFilters={handleApplyFilters}
              refresh={refresh}
            />
          </Box>

          {/* <Box item pr={2}>
            <ImportDialog
              title={t("RAL0171")}
              downloadTemplate={() => downloadUserImportTemplate()}
              onImport={(file) => handleImport(file)}
            />
          </Box> */}

          <Box item pr={2}>
            <Box
              sx={{
                "& .refresh_svg": {
                  transition: "color 0.3s ease",
                  color: mode === "dark" ? "var(--color-33-50)" : "#242424cc",
                },
                "&:hover": {
                  "& .hover-text, & .refresh_svg": {
                    color: mode === "dark" ? "#f8f8f8cc" : "#242424",
                  },
                },
              }}
            >
              <CustomIconButton
                id="btn-refresh-project"
                title={t("RAL0169")}
                size={isXlScreen ? "large" : "md"}
                variant="square"
                lightMode={
                  <RefreshIcon
                    id="member-refresh-icon"
                    className="refresh_svg"
                    height={isXlScreen ? "18px" : "14px"}
                  />
                }
                darkMode={
                  <RefreshIcon
                    id="member-refresh-icon"
                    className="refresh_svg"
                    height={isXlScreen ? "18px" : "14px"}
                  />
                }
                onClick={() => resetFilter()}
              />
            </Box>
          </Box>

          <Box item pr={2}>
            <Box
              sx={{
                "& .table_view_svg": {
                  transition: "color 0.3s ease",
                  color: mode === "dark" ? "var(--color-33-50)" : "#242424cc",
                },
                "&:hover": {
                  "& .hover-text, & .table_view_svg": {
                    color: mode === "dark" ? "#f8f8f8cc" : "#242424",
                  },
                },
              }}
            >
              <CustomIconButton
                id="btn-switch-project"
                title={t("RAL0266")}
                size={isXlScreen ? "large" : "md"}
                variant="square"
                lightMode={
                  <TableViewListIcon
                    id="member-switch-icon"
                    className="table_view_svg"
                    height={isXlScreen ? "18px" : "14px"}
                  />
                }
                darkMode={
                  <TableViewListIcon
                    id="member-switch-icon"
                    className="table_view_svg"
                    height={isXlScreen ? "18px" : "14px"}
                  />
                }
                onClick={handleSwitch}
              />
            </Box>
          </Box>

          {(role === "OWNER" || role === "ADMIN" || role === "HR_MANAGER") && (
            <CustomIconButton
              id="btn-custom-add-member"
              name="btn-custom-add-member"
              title={t("RAL0226")}
              size={isXlScreen ? "large" : "md"}
              variant="square"
              type="contained"
              border={"none"}
              lightMode={
                <AddIcon
                  id="member-add-icon"
                  height={isXlScreen ? "18px" : "14px"}
                />
              }
              darkMode={
                <AddIcon
                  id="member-add-icon"
                  height={isXlScreen ? "18px" : "14px"}
                />
              }
              onClick={handleAddMembers}
            />
          )}
        </>
      )}
    </Box>
  );

  const columns = React.useMemo(() => [
    {
      field: "memberName",
      headerName: t("RAL0239"),
      sortable: false,
      flex: 1,
      width: 10,

      renderCell: (params) => (
        <Tooltip
          title={params.row.memberName}
          placement="bottom-start"
          disableInteractive={false}
        >
          <span style={{ textTransform: "none" }}>{params.row.memberName}</span>
        </Tooltip>
      ),
    },
    {
      field: "email",
      headerName: t("RAL0003"),
      sortable: false,
      flex: 1,
      width: 10,
      renderCell: (params) => (
        <Tooltip
          title={params.row.email}
          placement="bottom-start"
          disableInteractive={false}
        >
          <span className="text-lowercase">{params.row.email}</span>
        </Tooltip>
      ),
    },

    {
      field: "source",
      headerName: t("RAL0536"),
      headerAlign: "center",
      sortable: false,
      textAlign: "center",
      flex: 1,
      width: 10,
      renderCell: (params) => (
        <Tooltip title={params.row.source === "BIOTIME" ? t("RAL0485") : ""}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100%"
          >
            {params.row.source === "BIOTIME" ? (
              <BiotimeIcon
                id="member-biotime-icon"
                style={{ marginTop: "4px" }}
              />
            ) : (
              "-"
            )}
          </Box>
        </Tooltip>
      ),
    },

    {
      field: "roleName",
      headerName: t("RAL0243"),
      sortable: false,
      flex: 1,
      width: 10,
      renderCell: (params) => (
        <Tooltip
          title={params.row.roleName}
          placement="bottom-start"
          disableInteractive
        >
          <span>{params.row.roleName}</span>
        </Tooltip>
      ),
    },
    {
      field: "designationName",
      headerName: t("RAL0244"),
      sortable: false,
      flex: 1,
      width: 10,
      renderCell: (params) => (
        <Tooltip
          title={params.row.designationName}
          placement="bottom-start"
          disableInteractive
        >
          <span>{params.row.designationName}</span>
        </Tooltip>
      ),
    },
    {
      field: "departmentName",
      headerName: t("RAL0245"),
      sortable: false,
      flex: 1,
      width: 10,
      renderCell: (params) => (
        <Tooltip
          title={params.row.departmentName}
          placement="bottom-start"
          disableInteractive
        >
          <span>{params.row.departmentName}</span>
        </Tooltip>
      ),
    },

    {
      field: "status",
      headerName: t("RAL0267"),
      sortable: false,
      flex: 1,
      width: 10,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const statusClass =
          params.row.status === "ACTIVE"
            ? "active-member-listview"
            : params.row.status === "INACTIVE"
              ? "inactive-member-listview"
              : params.row.status === "ARCHIVED"
                ? mode === "dark"
                  ? "archived-member-listview-dark"
                  : "archived-member-listview"
                : "";

        return (
          <Tooltip
            title={
            params.row.status.charAt(0).toUpperCase() +
            params.row.status.slice(1).toLowerCase()
            }
            placement="bottom-start"
            disableInteractive
          >
            <span
              className={statusClass}
              style={{
                display: "inline-block",
                width: "80px",
                minWidth: "80px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                textAlign: "center",
              }}
            >
              {params.row.status === "ACTIVE"
                ? t("RAL0232")
                : params.row.status === "INACTIVE"
                  ? t("RAL0233")
                  : t("RAL0234")}
            </span>
          </Tooltip>
        );
      },
    },

    {
      field: "weeklyWorkCapacity",
      headerName: t("RAL0254"),
      sortable: false,
      flex: 1,
      width: 10,
      renderCell: (params) => (
        <Tooltip
          title={`${params.row.weeklyWorkCapacity} ${t("RAL0665")}`}
          placement="bottom-start"
          disableInteractive
        >
          <span>
            {params.row.weeklyWorkCapacity} {t("RAL0665")}
          </span>
        </Tooltip>
      ),
    },

    role !== "EMPLOYEE" &&
    role !== "CLIENT" &&
    role !== "TEAM LEAD" && 
    role !== "MANAGER" && {
      headerName: t("RAL0538"),
      type: "actions",
      headerAlign: "left",
      flex: 1,
      width: 10,
      renderCell: (params) => (
        <>
          {params.row.status === "ARCHIVED" ? (
            <Tooltip title={t("RAL0535")}>
              <div style={{ marginLeft: "10%" }}>
                <GridActionsCellItem
                  icon={
                    mode === "dark" ? (
                      <UnarchiveDarkIcon
                        id="member-archive-icon"
                        className="icon"
                      />
                    ) : (
                      <UnarchiveIcon
                        id="member-archive-icon"
                        className="icon"
                      />
                    )
                  }
                  label={t("RAL0535")}
                  onClick={() => handleUnarchiveMembers(params.row.id)}
                />
              </div>
            </Tooltip>
          ) : (
            <>
              {(role === "OWNER" || params.row.roleName !== "Owner") && (
                <Tooltip title={t("RAL0172")}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      width: "150px",
                    }}
                  >
                    <GridActionsCellItem
                      icon={
                        mode === "dark" ? (
                          params.row.roleName === "Owner" ? (
                            <EditIconDark
                              id="member-edit-icon-owner"
                              className="Edit-icon"
                            />
                          ) : (
                            <EditIconDark
                              id="member-edit-icon"
                              className="Edit-icon"
                            />
                          )
                        ) : params.row.roleName === "Owner" ? (
                          <EditIcon
                            id="member-edit-icon-owner"
                            className="Edit-icon"
                          />
                        ) : (
                          <EditIcon
                            id="member-edit-icon"
                            className="Edit-icon"
                          />
                        )
                      }
                      label={t("RAL0172")}
                      onClick={() => handleEditMembers(params.row.id, "list", params.row.roleName)}
                    />
                  </div>
                </Tooltip>
              )}

              {params.row.roleName !== "Owner" && (
                <Tooltip title={t("RAL0173")}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      width: "250px",
                    }}
                  >
                    <GridActionsCellItem
                      icon={
                        mode === "dark" ? (
                          <ArchiveIconDark
                            id="member-archive-icon"
                            className="icon"
                          />
                        ) : (
                          <ArchiveIcon
                            id="member-archive-icon"
                            className="icon"
                          />
                        )
                      }
                      label={t("RAL0173")}
                      onClick={() => handleArchiveMember(params.row.id)}
                    />
                  </div>
                </Tooltip>
              )}
            </>
          )}
        </>
      ),
    },
  ]);

  const handleRowSelection = (newSelection) => {
    if (isEditingRef.current) {
      return;
    }
    const ownerRows = rows
      .filter((row) => row.roleName === "Owner")
      .map((row) => row.id);
    const isAddingOwner = newSelection.some((id) => ownerRows.includes(id));
    if (
      selectedRows.length === rows.length - ownerRows.length &&
      isAddingOwner
    ) {
      // toast.error(t("RAL0754"));
      return;
    }
    if (newSelection.length === rows.length) {
      const newSelectedRows = newSelection.filter(
        (id) => !ownerRows.includes(id)
      );
      setSelectedRows(newSelectedRows);
      return;
    }
    if (isAddingOwner) {
      const newSelectedRows = newSelection.filter(
        (id) => !ownerRows.includes(id)
      );
      setSelectedRows(newSelectedRows);
      // toast.error(t("RAL0754"));
      return;
    }
    setSelectedRows(newSelection);
  };

  const handleConfirmArchive = async () => {
    handleCloseDialog();
    try {
      let memberIds = [];
      if (archiveButton === "single") {
        memberIds = [selectedMemberId];
      }
      if (archiveButton === "all") {
        memberIds = selectedRows;
      }

      if (memberIds.length === 1) {
        const response = await softDeleteMember(memberIds[0]);
        if (response.data?.code === "RCI0000") {
          loadMembersData(page, rowsPerPage);
          toast.success(t("RAL0265"));
          setSelectedRows([]);
          setArchiveButton("");
          setSelectedMemberId(null);
          handleCloseDialog();
        } else {
          toast.error(response.data?.message);
        }
      } else if (memberIds.length > 1) {
        const payload = { ids: memberIds };
        const res = await batchMembersArchive(payload);
        if (res.data?.code === "RCI0000") {
          loadMembersData(page, rowsPerPage);
          toast.success(t("RAL0265"));
          setSelectedRows([]);
          setArchiveButton("");
          setSelectedMemberId(null);
          handleCloseDialog();
        } else {
          toast.error(res.data?.message);
        }
      } else {
        toast.error(t("RAL0525"));
      }
    } catch (error) {
      console.log(error);
      toast.error(t("RAL0537"));
    }
  };

  const handleConfirmUnrchive = async () => {
    try {
      let memberIds = [];
      if (archiveButton === "single") {
        memberIds = [selectedMemberId];
      }
      if (archiveButton === "all") {
        memberIds = selectedRows;
      }

      if (memberIds.length >= 1) {
        const payload = { ids: memberIds };
        const res = await batchMembersUnarchive(payload);
        if (res.data?.code === "RCI0000") {
          setSelectedRows([]);
          setArchiveButton("");
          setSelectedMemberId(null);
          loadMembersData(page, rowsPerPage);
          toast.success(t("RAL0524"));
          handleCloseUnarchiveDialog();
        }
        // else if (res?.data?.code === "RCE0256") {
        //   handleCloseUnarchiveDialog();
        //   handleClose();
        //   if (!["OWNER"].includes(CommonUtil.getRoleCode())) {
        //     setRestrictPopupOpen(true);
        //   } else {
        //     setUpgradePopupOpen(true);
        //   }
        // } 
        else if (res?.data?.code === "RCE0257") {
          handleCloseUnarchiveDialog();
          handleClose();
          if (!["OWNER"].includes(CommonUtil.getRoleCode())) {
            setRestrictPopupOpen(true);
          } else {
            setUpgradePopupOpen(true);
          }
        } else if (res?.data?.code === "RCE0225") {
          handleCloseUnarchiveDialog();
          handleClose();
          if (!["OWNER"].includes(CommonUtil.getRoleCode())) {
            setRestrictPopupOpen(true);
          } else {
            setUpgradePopupOpen(true);
          }
        }
        else {
          toast.error(res.data?.message);
        }
      } else {
        toast.error(t("RAL0525"));
      }
    } catch (error) {
      console.log(error);
      toast.error(t("RAL0588"));
    }
  };

  return CommonUtil.isOwnerOrAdminOrTeamleadOrManagerOrHRManager() ? (
    <>
      <div>
        <ContentLayout
          id="header-text-member-name"
          title={t("RAL0222")}
          rowtitle={
            selectedRows.length > 0 ? (
              <strong className="selected-projects">
                {selectedRows.length} {t("RAL0214").toLocaleLowerCase()}
                {selectedRows.length > 1 ? "s" : ""} {t("RAL0599")}
              </strong>
            ) : null
          }
          actions={actions}
        // isLoading={isLoading}
        >
          <AddTeamLeadsToUsers
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
          />



          {
            isLoading || !dataFetched ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="300px"
              >
                {/* <CircularProgress /> */}
              </Box>
            ) : (
              <>

            <CustomDataTable
              page={page - 1}
              totalRecords={totalRecords}
              rowsPerPage={rowsPerPage}
              columns={columns}
              rows={rows}
              checkboxSelection={true}
              rowSelectionModel={selectedRows}
              onRowSelectionModelChange={handleRowSelection}
              getRowClassName={getRowClassName}
              noDataLabel={t('RAL0385')}
              noDataComponent={
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  width: "100%",
                  alignItems: "center",
                  height: "100%",
                }}
              >
              {mode === "dark" ? (<EmptyMemberListDark />) : (<EmptyMemberList />)}
              <Typography
                className="empty-list-title"
              >
                {t("RAL0385")}
              </Typography>
              </Box>
              }
              onPageChange={(e) => {
                const CurrentPage = CommonUtil.getPageNumber(e);
                setPage(CurrentPage);
              }}
              onPageSizeChange={(e) => {
                setRowsPerPage(e);
                setPage(1);
              }}
            />
          </>
          )}

          <ArchiveDialog
            open={openArchiveDialog}
            onClose={handleCloseDialog}
            onConfirm={handleConfirmArchive}
            name={t("RAL0214").toLocaleLowerCase()}
            type="Member"
          />

          <UnarchiveDialog
            open={openUnarchiveDialog}
            onClose={handleCloseUnarchiveDialog}
            onConfirm={handleConfirmUnrchive}
            name={t("RAL0214").toLocaleLowerCase()}
            type="Member"
          />


          {["OWNER"].includes(CommonUtil.getRoleCode()) && (
            <UpgradePopup
              open={upgradePopupOpen}
              onClose={() => setUpgradePopupOpen(false)}
              onConfirm={() => {
                if (CommonUtil.getRoleCode() === "OWNER") {
                  navigate("/subscription-manage");
                } else {
                  navigate("/page-not-found");
                }
              }}
              title={getPopupTitle(subscriptionDetails, t)}
              content={getPopupContent(subscriptionDetails, t)}
              cancelText={t("RAL0177")}
              confirmText={t("RAL0848")}
            />
          )
          }

          {
            !["OWNER"].includes(CommonUtil.getRoleCode()) && (
              <RestrictPermissionPopup
                open={restrictPopupOpen}
                onClose={() => setRestrictPopupOpen(false)}
                title={getPopupTitle(subscriptionDetails, t, true)}
                content={getPopupContent(subscriptionDetails, t, true)}
                cancelText={t("RAL0177")}
              />
            )
          }
        </ContentLayout >
      </div >
    </>
  ) : (
    <></>
  );
}

export default MembersListView;
